"use client";

import React from "react";
import Image from "next/image";

interface LogoLoadingIndicatorProps {
  open?: boolean;
}

export const LogoLoadingIndicator = ({ open }: LogoLoadingIndicatorProps) => {
  if (!open) return null;

  return (
    <div
      style={{
        position: "fixed",
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        zIndex: 9999,
        backgroundColor: "rgba(0, 0, 0, 0.3)",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
      }}
    >
      <div
        style={{
          animation: "logoBlink 1.5s ease-in-out infinite",
        }}
      >
        <style jsx>{`
          @keyframes logoBlink {
            0% {
              opacity: 1;
            }
            50% {
              opacity: 0.3;
            }
            100% {
              opacity: 1;
            }
          }
        `}</style>
        <Image
          src="/loader-image.png"
          alt="DIM Dashboard"
          width={80}
          height={80}
          priority
          unoptimized
        />
      </div>
    </div>
  );
};
